<!-- MODAL HEADER -->
<div class="modal-header">
  <h3 class="modal-title">
    <strong>Edit Component Defaults</strong>
  </h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- MODAL BODY -->
<div class="modal-body" [hidden]="minimise">
  <div>
    <form name="screenFrom" class="form-horizontal" novalidate>

      <!-- DROPDOWNS ROW -->
      <div style="margin: 0 10px 15px 10px;">
        @if (!loading) {
<div class="dropdown-row">

            <div class="dropdown-item">
              <label>Basket</label>
              <select class="form-control" name="sourceCodes-typ"
                      [(ngModel)]="selectedSourceCode">
                <option [ngValue]="null">Select</option>
                @for (s of sourceData; track $index) {
<option [ngValue]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="dropdown-item">
              <label>FDII</label>
              <select class="form-control" name="fdiiCodes-typ"
                      [(ngModel)]="selectedFdiiCode">
                <option [ngValue]="null">Select</option>
                @for (s of fdiiData; track $index) {
<option [ngValue]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="dropdown-item">
              <label>Country</label>
              <select class="form-control" name="countryCodes-type"
                      [(ngModel)]="selectedCountryCode">
                <option [ngValue]="null">Select</option>
                @for (s of countryData; track $index) {
<option [ngValue]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="dropdown-item">
              <label>Prorate COGS</label>
              <select class="form-control" name="prorate-type"
                      [(ngModel)]="selectedProrateCOGS">
                <option [ngValue]="null">Select</option>
                @for (s of prorateYesNoData; track $index) {
<option [ngValue]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="dropdown-item">
              <label>GP Variances</label>
              <select class="form-control" name="gpVariances-type"
                      [(ngModel)]="selectedgpVariances">
                <option [ngValue]="null">Select</option>
                @for (s of gpVarianceData; track $index) {
<option [ngValue]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="dropdown-item">
              <label>SIC Code</label>
              <select class="form-control" name="sicCodes-type"
                      [(ngModel)]="selectedSicCode">
                <option [ngValue]="null">Select</option>
                @for (s of sicCodeData; track $index) {
<option [ngValue]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="dropdown-item">
              <label>FSE</label>
              <select class="form-control" name="fse-type"
                      [(ngModel)]="selectedFSC">
                <option [ngValue]="null">Select</option>
                @for (s of yesNoData; track $index) {
<option [ngValue]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="dropdown-item">
              <label>Financial Corp</label>
              <select class="form-control" name="financial-type"
                      [(ngModel)]="selectedFinancialCorp">
                <option [ngValue]="null">Select</option>
                @for (s of yesNoData; track $index) {
<option [ngValue]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="dropdown-item">
              <label>Expense A&amp;A Method</label>
              <select class="form-control" name="method"
                      [(ngModel)]="selectedMethod">
                <option [ngValue]="null">Select</option>
                @for (s of methodData; track $index) {
<option [ngValue]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

        </div>
}
      </div>

        <!-- DATA TABLE -->
        <div class="row">
          <div class="col-md-12">
            <div class="table-scroll" style="padding-top: 0 !important;">
              <table class="main-table">
                <thead>
                  <tr>
                    <th class="sticky-col"></th>
                    <th class="sticky-col" style="text-align: center;">HO LEID</th>
                    <th class="sticky-col" style="text-align: center;">LEID</th>
                    <th class="sticky-col" style="text-align: center;">Tax Code</th>
                    <th class="sticky-col" style="text-align: center;">Reporting Period</th>
                    <th class="sticky-col" style="text-align: center;">ME Code</th>
                    <th class="sticky-col" style="text-align: center;">Parent ME Code</th>
                    <th class="sticky-col" style="text-align: center;">US Tax Type</th>
                    <th class="sticky-col" style="text-align: center;">Basket</th>
                    <th class="sticky-col" style="text-align: center;">FDII</th>
                    <th class="sticky-col" style="text-align: center;">Country</th>
                    <th class="sticky-col" style="text-align: center;">Prorate COGS</th>
                    <th class="sticky-col" style="text-align: center;">GP Variances</th>
                    <th class="sticky-col" style="text-align: center;">SIC Code</th>
                    <th class="sticky-col" style="text-align: center;">FSE</th>
                    <th class="sticky-col" style="text-align: center;">Financial Corp</th>
                    <th class="sticky-col" style="text-align: center;">Expense A&amp;A Method</th>
                  </tr>
                </thead>
                <tbody>
                  @for (t of defaultsMultipleSelected; track $index) {
<tr>
                    <td>
                      <i class="fa fa-times" style="cursor: pointer;" title="Remove Row"
                         (click)="removeDefaultsRow(t)"></i>
                    </td>
                    <td>{{ t.HO_LEID }}</td>
                    <td>{{ t.LEID }}</td>
                    <td>{{ t.CDR_NO }}</td>
                    <td>{{ t.REPORTING_PERIOD }}</td>
                    <td>{{ t.ME_CODE }}</td>
                    <td>{{ t.PARENT_ME_CODE }}</td>
                    <td>{{ t.LE_TAX_TYPE }}</td>
                    <td>{{ t.BASKET_0 }}</td>
                    <td>{{ t.FDII_0 }}</td>
                    <td>{{ t.COUNTRY_0 }}</td>
                    <td>{{ t.PRORATE_COGS_0 }}</td>
                    <td>{{ t.GP_VARIANCES_0 }}</td>
                    <td>{{ t.SIC_CODES_0 }}</td>
                    <td>{{ t.FSE_0 }}</td>
                    <td>{{ t.FINANCIAL_CORP_0 }}</td>
                    <td>{{ t.METHOD_0 }}</td>
                  </tr>
}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      <!-- MODAL FOOTER -->
      <div class="modal-footer">
        <button class="btn btn-info btn-sm" type="button"
                (click)="save()"
                [disabled]="isSaveClicked || lockedRowExist">
          @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
        </button>
        <button class="btn btn-danger-outline btn-sm" type="button"
                (click)="reset()">
          Reset
        </button>
        <button class="btn btn-warning btn-sm" type="button"
                (click)="cancel()">
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
